// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__4rDDl","select":"Header_select__K6gls","clinic":"Header_clinic__1LfhX"};